// Reusable helpers for adding photos to card face or photozone
import { setIsImageEditDrawerOpen } from '../../../context/app-context';

export function createPhotoFromImage(image: any) {
  return {
    refId: image.data.refId,
    id: image.data.imageId,
    url: image.data.url,
    size: {
      width: image.width,
      height: image.height,
    },
  };
}

export function setImageOnSelect(
  image: any,
  appDispatch: any,
  isReplacingImage: any,
  updateEditFormats: any,
  firstElementSelected: any,
) {
  image.onSelect = () => {
    setIsImageEditDrawerOpen(appDispatch);
    !isReplacingImage.current && updateEditFormats({ eventAction: !firstElementSelected.current ? 'start' : 'add' });
    return false;
  };
}
